import { ClientProxy } from '../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../base/models'
import { ISaveVideoProgressRequest } from '../models/models'

export class SaveVideoProgressApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'Video/saveProgress',
      requesterInfo,
    })
  }

  public async saveProgress(request: ISaveVideoProgressRequest): Promise<boolean> {
    return await this.postAsync<boolean>(request)
  }
}
